import jwt_decode from "jwt-decode";

import { AUTH_TOKEN_HEADER } from "@assets/constants";
import { JWTToken } from "@assets/types";
import { openPasswordModal } from "@state/slices/userProfileSlice";
import store from "@state/store";

let intervalFunction: NodeJS.Timeout;

export const setAccessTokenExpiryInterval = (
  token: string,
  expiryCheckInterval = 60000, // 300 seconds
  expiryBuffer = 300 // 60 seconds
) => {
  const decoded: JWTToken = jwt_decode(token);
  clearTimeout(intervalFunction);
  intervalFunction = setInterval(() => {
    if (decoded.exp - expiryBuffer < Math.floor(Date.now() / 1000)) {
      store.dispatch(openPasswordModal());
    }
  }, expiryCheckInterval);
};

export const clearAccessTokenExpiryInterval = () => {
  localStorage.removeItem(AUTH_TOKEN_HEADER);
  clearInterval(intervalFunction);
};
